import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

/** ``/passports-index.json`` — the fichas this build published
 * (``scripts/prerender_fichas.py``). The edge answers any other
 * ``/isin/<ISIN>`` with 404, so a link must stay inside this list. */
export const PassportsIndex = z.object({
  items: z.array(z.object({ isin: z.string() })),
});
export type PassportsIndex = z.infer<typeof PassportsIndex>;

/** Published ISINs, or a failed query when the index is absent: a dev
 * server has no prerender and answers every ``/isin`` route itself. */
export function usePublishedIsins() {
  return useQuery({
    queryKey: ["published-isins"],
    queryFn: async () => {
      const r = await fetch("/passports-index.json", {
        headers: { Accept: "application/json" },
      });
      if (!r.ok) throw new Error(`HTTP ${r.status} for /passports-index.json`);
      const index = PassportsIndex.parse(await r.json());
      return new Set(index.items.map((i) => i.isin));
    },
    retry: false,
    staleTime: Infinity,
  });
}
